function getFaviconPath(faviconId: string) {
  return `/img/logo/logos_doctrine/favicon/${faviconId || 'favicon'}`;
}

export function changeFavicon(withNotification: boolean) {
  const favicons = document.querySelectorAll('link[rel="icon"]');

  if (favicons && favicons.length) {
    /** Simple for loop required for IE compatibility */
    for (let index = 0; index < favicons.length; index++) {
      const favicon = favicons[index];
      const faviconId = favicon.getAttribute('id') || '';
      favicon.setAttribute(
        'href',
        withNotification
          ? `${getFaviconPath(faviconId)}_notif.png`
          : `${getFaviconPath(faviconId)}.png`,
      );
    }
  }
}
